import { cx } from '@linaria/core';
import { avoidBreakInside } from '@provider/print';
import { poolCouponRowInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { useInputState } from '../../hook.use-input-state.js';
import { stickyContentWrapper, cellContent, stickyCellSpacer, cell, stickyLeftColumnCell } from './_task.pool-coupon.style.js';
import { Cross } from './atom.cross.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function RowInput(props) {
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => poolCouponRowInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.input.id])
  });
  const onChange = index => {
    update(props.taskEntryKey, props.input.id, {
      type: "pool-coupon-row",
      selectedColumnIndex: inputEntry?.selectedColumnIndex === index ? null : index
    });
  };
  const state = useInputState(props.input, inputEntry);
  return /*#__PURE__*/jsxs("tr", {
    ...avoidBreakInside(),
    children: [/*#__PURE__*/jsxs("th", {
      className: cx(cell, stickyLeftColumnCell),
      children: [/*#__PURE__*/jsx("div", {
        className: stickyContentWrapper,
        children: /*#__PURE__*/jsx("span", {
          className: cellContent,
          children: props.input.text
        })
      }), /*#__PURE__*/jsx("div", {
        className: cx(cellContent, stickyCellSpacer),
        children: props.input.text
      })]
    }), new Array(props.amountOfColumns).fill(undefined).map((_, index) => {
      const crossState = (() => {
        if (state === "input") {
          return "input";
        }
        if (state === "readonly") {
          return "readonly";
        }
        if (state === "correct") {
          return index === props.input.validation.correctColumnIndex ? "correct" : "readonly";
        }
        if (state === "incorrect") {
          if (index === props.input.validation.correctColumnIndex) {
            return "should-have";
          }
          if (index === inputEntry?.selectedColumnIndex) {
            return "incorrect";
          }
          return "readonly";
        }
        return "readonly";
      })();
      return /*#__PURE__*/jsx("td", {
        className: cell,
        children: /*#__PURE__*/jsx("span", {
          className: cellContent,
          children: /*#__PURE__*/jsx(Cross, {
            checked: inputEntry?.selectedColumnIndex === index,
            state: crossState,
            onClick: () => onChange(index)
          })
        })
      }, index);
    })]
  });
}

export { RowInput };
//# sourceMappingURL=input.row.js.map
